<script setup lang="ts">

import type { HTMLAttributes } from 'vue';

defineProps<{
  onLogout:() => void,
  classMobile?: HTMLAttributes['class'],
}>();
const { name } = usePortalContact();
</script>
<template>
  <div class="flex items-center justify-between gap-3 w-full">
    <div :class="['flex items-center gap-3 min-w-0 flex-1', classMobile]">
      <LayoutHeaderMobileSidebar />
      <div class="min-w-0">
        <LayoutSidebarSchool />
      </div>
    </div>
    <LayoutHeaderProfile
      class="shrink-0 ms-auto"
      :name="name"
      :logout="onLogout"
    />
  </div>
</template>
